export function updateFilter (state, filter) {
  state.filter = filter
}
